import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

async function buildApiError(resp) {
    let errorMessage;
    try {
        const data = await resp.json()
        errorMessage = data?.error;       
    }
    catch {}
    return {
        code: resp.status,
        error: errorMessage ?? resp.statusText
    };
}


export const fetchFiles = createAsyncThunk('userdataSlice/fetchFiles', async (userData, { rejectWithValue }) => {
    const resp = await fetch("/api/files")
    if (!resp.ok) return rejectWithValue(await buildApiError(resp));
    
    const data = await resp.json()
    return data;
});

export const checkAuthenticationStatus = createAsyncThunk('userdataSlice/checkAuthenticationStatus', async (userData, { rejectWithValue }) => {
    const resp = await fetch('/api/users/me');
    if (!resp.ok) return rejectWithValue(await buildApiError(resp));
    
    const data = await resp.json()
    return data;
});

export const submitLogin = createAsyncThunk('userdataSlice/submitLogin', async (userData, { rejectWithValue }) => {
  const resp = await fetch ('/api/auth/login', {
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(userData)
  })

  if (!resp.ok) return rejectWithValue(await buildApiError(resp));
    
  const data = await resp.json()
  return data;
});



export const userdataSlice = createSlice({
  name: 'userdata',
  initialState: {
    loginStateChecked: false,
    currentUser: undefined
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(checkAuthenticationStatus.fulfilled, (state, action) => {
      state.currentUser = action.payload.username;
      state.loginStateChecked = true;
    });
    builder.addCase(checkAuthenticationStatus.rejected, (state, action) => {
      state.currentUser = undefined;
      state.loginStateChecked = true;
    })
    builder.addCase(submitLogin.fulfilled, (state, action) => {
      state.currentUser = action.meta.arg.username;
      state.loginStateChecked = true;
    })
    builder.addCase(fetchFiles.rejected, (state, action) => {
      state.currentUser = undefined;
      state.loginStateChecked = true;
    })
  }
})

// Action creators are generated for each case reducer function
// export const { increment, decrement, incrementByAmount } = userdataSlice.actions

export default userdataSlice.reducer;

export const selectAuthenticationState = (state) => state.userdata.loginStateChecked ? (!!state.userdata.currentUser ? 'authenticated' : 'unauthenticated') : 'pending' ;
